module.exports = __webpack_public_path__ + "static/media/reset-button.53597e5a.svg";